import { api } from 'store/api';
import { ApiResponse } from 'store/api/types';

import { TaxRateTemplateToSave, TaxRateTemplate } from './models';
import { TaxRate } from 'store/returns/models/returnData';
import { CoaAccountRow } from 'store/chart-of-accounts/models';

export const saveTaxRateTemplate = (
  connectionId: string,
  taxRateTemplate: TaxRateTemplateToSave
): Promise<ApiResponse> =>
  api.post<ApiResponse>(`/rates/template/${connectionId}`, {
    body: taxRateTemplate,
  });

export interface FetchTaxRateTemplatesResponse extends ApiResponse {
  data: { templates: TaxRateTemplate[] };
}

export const getTaxRateTemplates = (): Promise<FetchTaxRateTemplatesResponse> =>
  api.get<FetchTaxRateTemplatesResponse>(`/rates/templates`);

export const deleteTaxRateTemplate = (
  templateId: string
): Promise<ApiResponse> =>
  api.delete<ApiResponse>(`/rates/template/${templateId}`);

export const editTaxRateTemplateName = (
  templateId: string,
  name: string
): Promise<ApiResponse> =>
  api.put<ApiResponse>(`/rates/template/${templateId}/name`, {
    body: { name },
  });

export interface FetchTaxRatesByCountryResponse extends ApiResponse {
  data: { taxRates: TaxRate[] };
}

export const getTaxRatesByCountry = (
  countryId: string
): Promise<FetchTaxRatesByCountryResponse> =>
  api.get<FetchTaxRatesByCountryResponse>(`/rates/country/${countryId}`);

export interface SaveTaxRatesResponse extends ApiResponse {
  data: { taxRates: TaxRate[] };
}

export const saveTaxRates = (
  connectionId: string,
  rates: string[]
): Promise<SaveTaxRatesResponse> =>
  api.post<SaveTaxRatesResponse>(`/rates/taxRates/${connectionId}`, {
    body: { rates },
  });

export const updateExcelTaxRate = (
  connectionId: string,
  taxRateId: string,
  taxName: string
): Promise<ApiResponse> =>
  api.put<ApiResponse>(
    `/rates/excel/${connectionId}/${taxRateId}?taxName=${encodeURIComponent(
      taxName
    )}`
  );

export const deleteExcelTaxRate = (
  connectionId: string,
  taxRateId: string
): Promise<ApiResponse> =>
  api.delete<ApiResponse>(`/rates/excel/${connectionId}/${taxRateId}`);

export interface ExcelTaxRateRequest {
  taxName: string;
  taxRate: number;
}
export const createExcelTaxRate = (
  connectionId: string,
  ExcelTaxRate: ExcelTaxRateRequest
): Promise<ApiResponse> =>
  api.post<ApiResponse>(`/rates/excel/${connectionId}`, {
    body: ExcelTaxRate,
  });
